// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-modal {
    font-weight: bold;
    color: red;
}

.my-success {
    font-weight: bold;
    color: forestgreen;
}


.webcam-style {
    width: 100%;
  }
  
  
  .overlay-container {
    position: absolute ;
    width: 100%;
    top: 0 ;
    right: 0 ;
    bottom: 0 ;
    left: 0;
  }
  
  .img-overlay-wrap {
    position: relative;
    width: 500px;
  }
  
  .rectstyle {
    top: 25%;
    bottom: 25%;
  }  



  .photoIcons {
    width: 100px;
    height: 60px;
    border-radius: 4px;
    border-top: 0px;
}

.capture-icon {
  width: 20%;
  height: 150px;
  margin-top: 0%;
}

.canvas-style {
  border-style: solid;
}

.w3-border {
  border: 1px solid #ccc!important;
}
.w3-container, .w3-panel {
  padding: 0.01em 16px;
  margin-top: 1%;
}
.w3-round-xlarge {
  border-radius: 16px;
}
.videodiv-style{
  margin-top: 1%;
}

/* === HEADING STYLE #3 === */
.three h1 {
  font-size: 25px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.5em;
  padding-bottom: 5px;
  position: relative;
}
.three h1:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 5px;
  width: 55px;
  background-color: #111;
}
.three h1:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 2px;
  height: 1px;
  width: 95%;
  max-width: 255px;
  background-color: #333;
}

h1 {
  position: relative;
  padding: 0;
  margin: 0;
  font-weight: 300;
  font-size: 40px;
  color: #080808;
  transition: all 0.4s ease 0s;
}

.proceedbtn {
  margin-top: 1%;
}

.capture-photo-desktop {
  margin-top: 1%;
  border-style: solid;
}

.capture-icon-desktop {
  width: 80%;
  height: 200px;
  margin-top: 1%;
}

.mobileIdsbox {
    width: 200px;
    margin-top: 30px;
    margin-left:10%;
}

.mobileIdbtns {
    float: left;
    clear: none;
}

.box {
    margin: 5px;
    width: 99%;
    border: 1px solid black;
    text-align: center;
    margin-top:5%;
}

 .box > h3 {
        position: absolute;
        background: white;
        height: 20px;
        margin-top: -12px;
        margin-left: 10px;
        padding: 0 10px;
 }

.nfcvisual {
    width: 50%;
    margin-top: 0px;
    height: 80%;
}

.mainbg {
    /*background: linear-gradient(235.9deg, #003087 19.67%, #0159F5 68.12%);*/
    background-color:#ffffff;
}

.contentarea {
    margin-top: 0%;
    gap: 0px;
    width: 100%;
    border-radius: 32px 32px 0px 0px;
    background: #FFFFFF;
}

.headerdisplay {
    font-weight: bold;
    color: #000000;
    text-align:center;
}

.headerdiv {
    margin-top: 0%;
    width: 100%;
}

.cornerbddisplay {
    position: absolute;
    right: 0px;
    top: 0px;
    background: rgba(147, 194, 248, 0);
    height: 150px;
}

.nfcabouticon {
    width: 10px;
    height: 10px;
}

.bannerdisplay {
    margin-top: 0px;
    height: 150px;
    display: flex;
    align-items:center;
}

.instructiondisplay {
    font-size: 20px;
}

.scancontentarea {
    margin-top: 0%;
    gap: 0px;
    width: 100%;
    height:100%;
    border-radius: 32px 32px 0px 0px;
    background: #ffffff;/*#484C5B*/
}

.scanmrzzonedisplay {
    width: 100%;
    height: 300px;
    margin-top: 15%;
    background: linear-gradient(235.9deg, #003087 19.67%, #0159F5 68.12%);
    border-radius: 32px 32px 32px 32px;
    position: relative;
}

.mrzmodeldisplay {
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.scaninstructiondisplay {
    font-size: 20px;
}

.footerdisplay {
    margin-top: auto;
}

.bodycontentdisplay {
    min-height: 83vh;
    display: flex;
    flex-direction: column;
}

@supports (height: 100dvh) {
    .bodycontentdisplay {
        min-height: 83dvh; 
    }
}

.home-button {
    border: 2px solid #007bff; /* Blue border */
    background-color: transparent; /* No background */
    color: #007bff; /* Text color same as border */
    text-decoration: none;
    border-radius: 6px;
    font-size: 18px;
    transition: background-color 0.3s, color 0.3s;
    padding: 1px 18px;
}

    .home-button:hover {
        background-color: #007bff; /* Blue on hover */
        color: white;
    }`, "",{"version":3,"sources":["webpack://./src/pages/IDProofing.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,WAAW;EACb;;;EAGA;IACE,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,SAAS;IACT,UAAU;IACV,OAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;;;;EAIA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EAGd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;CAEC;QACO,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;QACjB,eAAe;CACtB;;AAED;IACI,UAAU;IACV,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yEAAyE;IACzE,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,WAAW;IACX,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,mBAAmB,CAAC,UAAU;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,qEAAqE;IACrE,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,6BAA6B,EAAE,kBAAkB;IACjD,cAAc,EAAE,8BAA8B;IAC9C,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,6CAA6C;IAC7C,iBAAiB;AACrB;;IAEI;QACI,yBAAyB,EAAE,kBAAkB;QAC7C,YAAY;IAChB","sourcesContent":[".my-modal {\n    font-weight: bold;\n    color: red;\n}\n\n.my-success {\n    font-weight: bold;\n    color: forestgreen;\n}\n\n\n.webcam-style {\n    width: 100%;\n  }\n  \n  \n  .overlay-container {\n    position: absolute ;\n    width: 100%;\n    top: 0 ;\n    right: 0 ;\n    bottom: 0 ;\n    left: 0;\n  }\n  \n  .img-overlay-wrap {\n    position: relative;\n    width: 500px;\n  }\n  \n  .rectstyle {\n    top: 25%;\n    bottom: 25%;\n  }  \n\n\n\n  .photoIcons {\n    width: 100px;\n    height: 60px;\n    border-radius: 4px;\n    border-top: 0px;\n}\n\n.capture-icon {\n  width: 20%;\n  height: 150px;\n  margin-top: 0%;\n}\n\n.canvas-style {\n  border-style: solid;\n}\n\n.w3-border {\n  border: 1px solid #ccc!important;\n}\n.w3-container, .w3-panel {\n  padding: 0.01em 16px;\n  margin-top: 1%;\n}\n.w3-round-xlarge {\n  border-radius: 16px;\n}\n.videodiv-style{\n  margin-top: 1%;\n}\n\n/* === HEADING STYLE #3 === */\n.three h1 {\n  font-size: 25px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.5em;\n  padding-bottom: 5px;\n  position: relative;\n}\n.three h1:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 5px;\n  width: 55px;\n  background-color: #111;\n}\n.three h1:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 2px;\n  height: 1px;\n  width: 95%;\n  max-width: 255px;\n  background-color: #333;\n}\n\nh1 {\n  position: relative;\n  padding: 0;\n  margin: 0;\n  font-weight: 300;\n  font-size: 40px;\n  color: #080808;\n  -webkit-transition: all 0.4s ease 0s;\n  -o-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n\n.proceedbtn {\n  margin-top: 1%;\n}\n\n.capture-photo-desktop {\n  margin-top: 1%;\n  border-style: solid;\n}\n\n.capture-icon-desktop {\n  width: 80%;\n  height: 200px;\n  margin-top: 1%;\n}\n\n.mobileIdsbox {\n    width: 200px;\n    margin-top: 30px;\n    margin-left:10%;\n}\n\n.mobileIdbtns {\n    float: left;\n    clear: none;\n}\n\n.box {\n    margin: 5px;\n    width: 99%;\n    border: 1px solid black;\n    text-align: center;\n    margin-top:5%;\n}\n\n .box > h3 {\n        position: absolute;\n        background: white;\n        height: 20px;\n        margin-top: -12px;\n        margin-left: 10px;\n        padding: 0 10px;\n }\n\n.nfcvisual {\n    width: 50%;\n    margin-top: 0px;\n    height: 80%;\n}\n\n.mainbg {\n    /*background: linear-gradient(235.9deg, #003087 19.67%, #0159F5 68.12%);*/\n    background-color:#ffffff;\n}\n\n.contentarea {\n    margin-top: 0%;\n    gap: 0px;\n    width: 100%;\n    border-radius: 32px 32px 0px 0px;\n    background: #FFFFFF;\n}\n\n.headerdisplay {\n    font-weight: bold;\n    color: #000000;\n    text-align:center;\n}\n\n.headerdiv {\n    margin-top: 0%;\n    width: 100%;\n}\n\n.cornerbddisplay {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    background: rgba(147, 194, 248, 0);\n    height: 150px;\n}\n\n.nfcabouticon {\n    width: 10px;\n    height: 10px;\n}\n\n.bannerdisplay {\n    margin-top: 0px;\n    height: 150px;\n    display: flex;\n    align-items:center;\n}\n\n.instructiondisplay {\n    font-size: 20px;\n}\n\n.scancontentarea {\n    margin-top: 0%;\n    gap: 0px;\n    width: 100%;\n    height:100%;\n    border-radius: 32px 32px 0px 0px;\n    background: #ffffff;/*#484C5B*/\n}\n\n.scanmrzzonedisplay {\n    width: 100%;\n    height: 300px;\n    margin-top: 15%;\n    background: linear-gradient(235.9deg, #003087 19.67%, #0159F5 68.12%);\n    border-radius: 32px 32px 32px 32px;\n    position: relative;\n}\n\n.mrzmodeldisplay {\n    max-height: 100%;\n    max-width: 100%;\n    width: auto;\n    height: auto;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n.scaninstructiondisplay {\n    font-size: 20px;\n}\n\n.footerdisplay {\n    margin-top: auto;\n}\n\n.bodycontentdisplay {\n    min-height: 83vh;\n    display: flex;\n    flex-direction: column;\n}\n\n@supports (height: 100dvh) {\n    .bodycontentdisplay {\n        min-height: 83dvh; \n    }\n}\n\n.home-button {\n    border: 2px solid #007bff; /* Blue border */\n    background-color: transparent; /* No background */\n    color: #007bff; /* Text color same as border */\n    text-decoration: none;\n    border-radius: 6px;\n    font-size: 18px;\n    transition: background-color 0.3s, color 0.3s;\n    padding: 1px 18px;\n}\n\n    .home-button:hover {\n        background-color: #007bff; /* Blue on hover */\n        color: white;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
